import { useContext } from 'react';
import propTypes from 'prop-types';
import { css, cx } from '@eti/styles';
import isFunction from 'lodash/isFunction';
import { RadioGroupContext } from '../radio_group/RadioGroup';
import RadioButton from '../radio_button/RadioButton';
import { jsx as _jsx } from "react/jsx-runtime";
const labelStyles = css`
  align-items: normal;
  display: inline-block;
  font-weight: 400;
  padding-left: 1.875rem;

  html[dir='rtl'] & {
    left: auto;
    padding-left: 0;
    padding-right: 1.875rem;
    right: 0;
  }

  @media (min-width: 60.625em) {
    padding-left: 1.8125rem;

    html[dir='rtl'] & {
      padding-left: 0;
      padding-right: 1.8125rem;
    }
  }
`;
const customRadioStyles = css`
  position: absolute;
`;
const EtiRadio = _ref => {
  let {
    className,
    children,
    id,
    isNeutral,
    dataTestId,
    value,
    ...rest
  } = _ref;
  const {
    radioGroup: {
      name,
      selectedValue,
      onChange
    }
  } = useContext(RadioGroupContext);
  const handleOnchange = () => {
    if (isFunction(onChange)) {
      onChange(value);
    }
  };
  const areValuesEqual = () => {
    if (Array.isArray(value) && Array.isArray(selectedValue)) {
      return JSON.stringify(value) === JSON.stringify(selectedValue);
    }
    return selectedValue !== undefined ? value === selectedValue : selectedValue;
  };
  return /*#__PURE__*/_jsx(RadioButton, {
    classNames: {
      label: cx(labelStyles, className),
      radio: customRadioStyles
    },
    id: id,
    isNeutral: isNeutral,
    isSelected: areValuesEqual(),
    labelTestId: dataTestId,
    name: name,
    onChange: handleOnchange,
    value: value,
    ...rest,
    children: children
  });
};
EtiRadio.propTypes = {
  children: propTypes.node,
  className: propTypes.string,
  dataTestId: propTypes.string,
  id: propTypes.string.isRequired,
  isNeutral: propTypes.bool,
  value: propTypes.oneOfType([propTypes.string, propTypes.number, propTypes.bool, propTypes.arrayOf(propTypes.shape({
    priceRaw: propTypes.number,
    value: propTypes.string
  }))])
};
export default EtiRadio;
//# sourceMappingURL=Radio.js.map